// src/utils/piiDetector.ts
// Detects personally identifiable information in story text.
// Runs client-side — no API call needed.
 
export interface PIIMatch {
    type: string;
    detail: string; // child-friendly explanation
  }
   
  const EMAIL_RE   = /[\w.+\-]+@[\w\-]+\.[a-zA-Z]{2,}/gi;
  const PHONE_RE   = /(\+?1[\s.\-]?)?\(?\d{3}\)?[\s.\-]\d{3}[\s.\-]\d{4}/g;
  const ADDRESS_RE = /\d{1,5}\s+\w[\w\s]{1,30}(street|st\.?|avenue|ave\.?|road|rd\.?|drive|dr\.?|lane|ln\.?|boulevard|blvd\.?|way|court|ct\.?|place|pl\.?)\b/gi;
  const SOCIAL_RE  = /@[\w.]{3,30}\s+(on\s+)?(instagram|tiktok|snapchat|discord|twitter|x\.com|roblox|youtube)/gi;
   
  export function detectPII(text: string): PIIMatch[] {
    const found: PIIMatch[] = [];
   
    const resetAll = () => {
      EMAIL_RE.lastIndex = 0;
      PHONE_RE.lastIndex = 0;
      ADDRESS_RE.lastIndex = 0;
      SOCIAL_RE.lastIndex = 0;
    };
   
    if (EMAIL_RE.test(text))   found.push({ type: 'email',   detail: "Remove the email address — sharing it online isn't safe." });
    if (PHONE_RE.test(text))   found.push({ type: 'phone',   detail: "Remove the phone number — keep it private!" });
    if (ADDRESS_RE.test(text)) found.push({ type: 'address', detail: "Remove the home address — never share where you live." });
    if (SOCIAL_RE.test(text))  found.push({ type: 'social',  detail: "Remove the social media handle — don't share accounts in stories." });
   
    resetAll();
    return found;
  }